import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Play, MessageCircle, ExternalLink, Film, Lock } from "lucide-react";
import { API } from "../lib/api";
import { VideoModal } from "./VideoModal";

export const MonumentSheet = ({ monument, onAskCatalina, onClose, premium, onBuy, sessionId }) => {
  const [videoOpen, setVideoOpen] = useState(false);

  return (
    <>
      <AnimatePresence>
        {monument && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 z-[600]"
              style={{ background: "rgba(5,6,9,0.55)" }}
              onClick={onClose}
            />
            <motion.div
              data-testid="monument-sheet"
              initial={{ y: "100%" }}
              animate={{ y: 0 }}
              exit={{ y: "100%" }}
              transition={{ type: "spring", damping: 30, stiffness: 300 }}
                            className="fixed top-8 left-0 right-0 z-[601] glass rounded-3xl mx-3 px-6 pt-4 pb-8 max-h-[80vh] overflow-y-auto thin-scroll"
              style={{ boxShadow: "0 -12px 40px rgba(0,0,0,0.6)" }}
            >
              <div className="flex justify-center mb-4">
                <div className="w-12 h-1.5 rounded-full" style={{ background: "rgba(212,175,55,0.3)" }} />
              </div>
              <button
                data-testid="monument-close-btn"
                onClick={onClose}
                className="absolute top-4 right-5 w-9 h-9 rounded-full flex items-center justify-center"
                style={{ background: "rgba(255,255,255,0.06)" }}
              >
                <X size={18} style={{ color: "#9ca3af" }} />
              </button>

              <span className="text-[11px] tracking-[0.3em] uppercase" style={{ color: "#8c7326" }}>
                Monumento
              </span>
              <h2 className="font-serif-display leading-none mt-1 text-4xl" style={{ color: "#f3f4f6" }}>
                {monument.title}
              </h2>
              <p className="font-serif-display italic mt-2 text-lg" style={{ color: "#d4af37" }}>
                {monument.short}
              </p>

              <p className="mt-4 text-[15px]" style={{ color: "#c7cad1", lineHeight: 1.65 }}>
                {monument.description}
              </p>

              {/* Vídeo: solo botón -> pantalla completa */}
              <div className="mt-6">
                               {monument.video_url ? (
                  <button
                    data-testid="monument-video-btn"
                    onClick={() => (premium ? setVideoOpen(true) : onBuy && onBuy())}
                    className="w-full rounded-2xl py-5 flex items-center justify-center gap-3 transition-all duration-300"
                    style={{ background: "rgba(212,175,55,0.10)", border: "1px solid rgba(212,175,55,0.3)" }}
                  >
                    <span
                      className="w-11 h-11 rounded-full flex items-center justify-center"
                      style={{ background: "rgba(212,175,55,0.18)" }}
                    >
                      {premium
                        ? <Play size={18} className="gold-text" style={{ marginLeft: 2 }} />
                        : <Lock size={17} className="gold-text" />}
                    </span>
                    <span className="text-left">
                      <span className="block text-sm font-semibold" style={{ color: "#f0c94a" }}>
                        {premium ? "Ver vídeo-pódcast" : "Desbloquear vídeo-pódcast"}
                      </span>
                      <span className="block text-[11px]" style={{ color: "#9ca3af" }}>
                                                {premium ? "Pantalla completa · aprox. 6 min" : "Acceso completo a todos los monumentos · 4,99 €"}
                      </span>
                    </span>
                  </button>
                ) : (
                  <div
                    className="w-full rounded-2xl py-6 text-center text-sm flex items-center justify-center gap-2"
                    style={{ background: "rgba(255,255,255,0.03)", border: "1px dashed rgba(255,255,255,0.1)", color: "#6b7280" }}
                  >
                    <Film size={15} /> Vídeo próximamente
                  </div>
                )}
              </div>

              

              
            </motion.div>
          </>
        )}
      </AnimatePresence>

      <VideoModal
        open={videoOpen}
        src={monument ? `${API}/video/${monument.id}?session_id=${encodeURIComponent(sessionId || "")}` : ""}
        title={monument?.title}
        onClose={() => setVideoOpen(false)}
      />
    </>
  );
};
